import React, { createContext, useContext, useState } from "react";
import { isNewCompany } from "../Domain/NewCampaign";

export enum QuestionSteps {
  INITIAL = 1,
  FINAL = 2,
}

type ServiceNeedContextType = {
  isThisANewCompany: boolean;
  accountingServiceNeed: boolean | null;
  setAccountingServiceNeed: (value: boolean) => void;
  holviServiceNeed: boolean | null;
  setHolviServiceNeed: (value: boolean) => void;
  hasInsurance: boolean | null;
  setHasInsurance: (value: boolean) => void;
  insuranceServiceNeed: boolean | null;
  setInsuranceServiceNeed: (value: boolean) => void;
  questionStep: QuestionSteps;
  setQuestionStep: (value: QuestionSteps) => void;
};

const ServiceNeedContext = createContext<ServiceNeedContextType | undefined>(undefined);

export const ServiceNeedProvider: React.FC<{ 
  children: React.ReactNode;
  tradeRegistrationYear: number;
}> = ({ children, tradeRegistrationYear }) => {
  const [accountingServiceNeed, setAccountingServiceNeed] = useState<boolean | null>(null);
  const [holviServiceNeed, setHolviServiceNeed] = useState<boolean | null>(null);
  const [hasInsurance, setHasInsurance] = useState<boolean | null>(null);
  const [insuranceServiceNeed, setInsuranceServiceNeed] = useState<boolean | null>(null);

  const isThisANewCompany = isNewCompany(tradeRegistrationYear);

  const [questionStep, setQuestionStep] = useState<QuestionSteps>(QuestionSteps.INITIAL);

  return (
    <ServiceNeedContext.Provider
      value={{
        isThisANewCompany,
        accountingServiceNeed,
        setAccountingServiceNeed,
        holviServiceNeed,
        setHolviServiceNeed,
        hasInsurance,
        setHasInsurance,
        insuranceServiceNeed,
        setInsuranceServiceNeed,
        questionStep,
        setQuestionStep,
      }}
    >
      {children}
    </ServiceNeedContext.Provider>
  );
};

export const useServiceNeedContext = () => {
  const context = useContext(ServiceNeedContext);

  if (!context) {
    throw new Error("useServiceNeedContext must be used within a ServiceNeedProvider");
  }
  
  return context;
};